/* eslint-disable new-cap */
/* eslint-disable no-new */
/**
 * Appointment booking javascript handler for form 97
 * https://app.asana.com/0/1186215122557462/1188205757883746/f
 */

/**
 * @typedef {Object} FormNavItem
 * @property {string} id The js id to be added to the rendered element
 * @property {string} title The nav item's title to be displayed
 * @property {string[]} paths The paths that the item should be active
 * @property {number} step The step position of the item
 * @property {string} formContainer The step's form container that should be displayed/hidden
 * @property {() => boolean} isValid
 * A callback to be called on form change to validate if the form is able to go to next step
 * @property {boolean} [isChecked] If the item is checked
 * @property {boolean} [isActive] If the item is active
 */

/**
 * @typedef {{ [key: string]: string | number }} AppointmentStore
 */

((window, document) => {
  const APT_STORE_KEY = '_appointmentStore';
  const APT_SLOT_STORE_KEY = '_appointmentSlotStore';
  const SMC_COOKIE = window.Cookie.get('date_time_combined') ?? undefined;

  /**
   * Regex to check if the form is added on find a dealer page
   */
  const FIND_A_DEALER_REG = /\/find-a-dealer\/([^/]+)\/book-an-appointment\/$/;
  const OUR_LOCATIONS_REG = /\/our-locations\/([^/]+)\/book-an-appointment\/$/;

  const FIND_A_DEALER_COOKIE_REG = /\/find-a-dealer\/([^/]+)\/$/;
  const OUR_LOCATIONS_COOKIE_REG = /\/our-locations\/([^/]+)\/$/;

  const DEALER_COOKIE = 'vertuDlr';

  const IS_MY_CAR_PAGE = window.location.pathname.includes('/my-car');

  const IS_SELL_YOUR_CAR_PAGE =
    window.location.pathname.includes('sell-my-car') ||
    window.location.pathname.includes('value-my-car');
  const IS_SELL_YOUR_CAR_APP =
    IS_SELL_YOUR_CAR_PAGE && !window.location.pathname.includes('book-an-appointment/sell-my-car');
  const IS_JULY_CAMPAIGN_URL = window.location.pathname.includes('book-an-appointment/sell-my-car');

  const IS_MOTORCYCLE_PAGE = window.IS_MOTORCYCLE_PAGE ? window.IS_MOTORCYCLE_PAGE : null;

  const { mktApptCampaign } = window;
  /**
   * Check if the form is used with the marketing campaign functionality or as a regular form.
   */
  const IS_CAMPAIGN_FORM =
    typeof mktApptCampaign !== 'undefined' &&
    mktApptCampaign.mktApptCampaignDates &&
    mktApptCampaign.mktApptCampaignDates.apptDates &&
    mktApptCampaign.mktApptCampaignDates.apptTimes;

  const HAS_CAMPAIGN_CODE = window.location.href.includes('utm_campaign');
  const urlSearchParams = new URLSearchParams(window.location.search);

  const SEARCH_ENDPOINT_URL = '/content/api/ajax_dealer_services.p';

  const SEARCH_DEFAULT_PARAMS = {
    Action: 'FindaDealer',
    startPos: 0,
    postcode: '',
    facilities: '',
    franchise: '',
    numRows: 3,
    sort: '',
    dlrname: '',
    openTimeSlots: 'YES',
  };

  const SEARCH_CURRENT_PARAMS = { ...SEARCH_DEFAULT_PARAMS };

  const selectDealershipBtn = '.js-select-dealership';
  let selectedDealership;

  const nearestDealershipsElements = {
    geolocatorContainer: '.js-geolocator-container',
    postcodeInput: '.js-geolocator-container input#Q200',
    geolocatorButton: '.js-geolocator',
    manufacturerSelect: 'select#manufacturer',
    dealerDropdownSelect: '#Q507',
    nearestDealershipsContainer: '.js-apt-nearest-dealership',
    showAllButton: '.js-apt-nearest-dealership-all',
    showMoreButton: '.js-apt-nearest-dealership-more',
  };

  /**
   * Store the form values in the store.
   * The keys are the input names and values are the input values
   * @type {AppointmentStore}
   */
  let appointmentStore;

  /**
   * @type {HTMLAnchorElement | HTMLButtonElement}
   */
  let stepContinueButton;

  /**
   * @type {HTMLAnchorElement | HTMLButtonElement}
   */
  let stepBackButton;

  /**
   * @type {HTMLButtonElement}
   */
  let stepCompleteButton;

  /**
   * Store the current step of the form. Defaults to step 1.
   */
  let currentStep = 1;

  const dealershipInputs = IS_SELL_YOUR_CAR_APP ? ['Q507'] : ['Q507'];

  const appBookChangeStageOrder = window.appBookChangeStageOrder
    ? window.appBookChangeStageOrder
    : null;

  function saveAppointmentStore() {
    if (appointmentStore && appointmentStore.Q507) {
      // if name includes following
      if (appointmentStore.Q507.includes('Mercedes Benz')) {
        // replace with following string so that hyphen is included
        appointmentStore.Q507 = appointmentStore.Q507.replace('Mercedes Benz', 'Mercedes-Benz');
      }
    }

    window.sessionStorage.setItem(APT_STORE_KEY, JSON.stringify(appointmentStore));
  }

  /**
   * @param {string} key
   * @param {any} value
   */
  function setAppointmentStoreKey(key, value) {
    appointmentStore[key] = value;
    saveAppointmentStore();
  }

  /**
   * Get the input from a list of inputs
   * @param {NodeList} inputs The input elements to get the input
   */
  function getInputFromList(inputs) {
    for (let i = 0, len = inputs.length; i < len; i += 1) {
      const el = inputs[i];

      if (/radio|checkbox/.test(el.type)) {
        if (el.checked) {
          return el;
        }
      } else {
        break;
      }
    }

    return inputs[0];
  }

  /**
   * Check if an array of inputs are valid
   * @param {string[]} ids The input ids to check
   */
  function isValidInputs(ids) {
    const idsToUse =
      currentStep === 1 && SMC_COOKIE === 'Combined' ? [...dealershipInputs, 'Q641', 'Q672'] : ids;
    return idsToUse.reduce((valid, id) => {
      const inputsById = document.querySelectorAll(`#${id}`);
      const inputs = inputsById.length
        ? inputsById
        : document.querySelectorAll(`input[name=${id}]`);
      const input = getInputFromList(inputs);

      if (input && input.name) {
        setAppointmentStoreKey(input.name, input.value);
      }

      if (!input) return valid;
      return (
        valid &&
        window.validator.forms.form_97 &&
        window.validator.forms.form_97.checkRules(
          input,
          window.validator.forms.form_97.vOptions.rules[id],
        ).valid
      );
    }, true);
  }

  /**
   * Store the nav items in order to define next/previous steps and
   * handle navigation
   * @type {FormNavItem[]}
   */
  let storedNavItems = [
    {
      id: 'js-your-dealership',
      title: 'Your dealership',
      paths: appBookChangeStageOrder ? ['your-dealership', ''] : ['your-dealership'],
      step: appBookChangeStageOrder ? 1 : 2,
      formContainer: 'js-dealership-block',
      isValid: () => isValidInputs(dealershipInputs),
    },
    {
      id: 'js-your-appointment',
      title: 'Your appointment',
      paths: appBookChangeStageOrder ? ['your-appointment'] : ['your-appointment', ''],
      step: appBookChangeStageOrder ? 2 : 1,
      formContainer: 'js-appointment-block',
      isValid: () => isValidInputs(['Q647']),
    },
    {
      id: 'js-date-and-time',
      title: 'Date and time',
      paths: ['date-and-time'],
      step: 3,
      formContainer: 'js-date-time-block',
      isValid: () => isValidInputs(['Q641', 'Q672']),
    },
    {
      id: 'js-your-details',
      title: 'Your details',
      paths: ['your-details'],
      step: 4,
      formContainer: 'js-details-block',
      isValid: () => isValidInputs(['Q2', 'Q3', 'Q41', 'Q45', 'Q59']),
    },
  ];

  /**
   * @type {boolean}
   * @description Change "dealership" to "retailer" when this variable is set to true
   */
  const jlrRetailer = window.jlrRetailer ? window.jlrRetailer : false;

  /**
   * @type {Object}
   */
  const appointmentDetails = {
    step: 1,
    vehicleType: '',
    vehicleMake: '',
    vehicleModel: '',
    vehicleFuelType: '',
    appointmentType: '',
    dealership: '',
    date: '',
    time: '',
    userData: {
      email: '',
      phone_number: '',
    },
  };

  /**
   * @param {string} string
   */
  function replaceDealership(string) {
    if (jlrRetailer && string) {
      if (string.includes('dealership')) {
        return string.replace('dealership', 'retailer');
      }
      if (string.includes('Dealership')) {
        return string.replace('Dealership', 'Retailer');
      }
    }
    return string;
  }

  /**
   * Smooth scroll to the provided element with an offset if provided
   * @param {HTMLElement} element The element to scroll to
   * @param {number} [offset=0] The offset to substract from the top
   */
  function smoothScroll(element, offset = 0) {
    if (!element) return;

    const top = element.getBoundingClientRect().top - offset;

    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollBy({
        top,
        behavior: 'smooth',
      });
    } else {
      window.scrollBy(0, top);
    }
  }

  /**
   * Clear element's content
   * @param {HTMLElement} element The element to clear
   */
  function clearElementContent(element) {
    while (element.firstChild && element.removeChild(element.firstChild));
  }

  function initAppointmentStore() {
    const sessionStorageStore = window.sessionStorage.getItem(APT_STORE_KEY);
    appointmentStore = sessionStorageStore ? JSON.parse(sessionStorageStore) : {};
  }

  function clearAppointmentStore() {
    appointmentStore = {};
    window.sessionStorage.removeItem(APT_STORE_KEY);
  }

  /**
   * @param {string} key
   * @returns {any}
   */
  function getAppointmentStoreKey(key) {
    if (Object.prototype.hasOwnProperty.call(appointmentStore, key)) {
      return appointmentStore[key];
    }

    return '';
  }

  /**
   * @returns {FormNavItem}
   */
  function getCurrentActiveItem() {
    return storedNavItems.filter((item) => item.step === currentStep)[0];
  }

  /**
   * @returns {FormNavItem}
   */
  function getNextActiveItem() {
    return storedNavItems.filter((item) => item.step === currentStep + 1)[0];
  }

  /**
   * @returns {FormNavItem}
   */
  function getPreviousActiveItem() {
    return storedNavItems.filter((item) => item.step === currentStep - 1)[0];
  }

  /**
   * Check if the passed item is active based on the provided pathname
   * @param {FormNavItem} navItem The nav item to check
   * @param {string} pathname The pathname to check
   */
  function isActiveStep(navItem, pathname) {
    for (let i = 0, len = navItem.paths.length; i < len; i += 1) {
      if (pathname.includes(navItem.paths[i])) {
        return true;
      }
    }

    return false;
  }

  /**
   * Handle the Google ReCaptcha State
   * @param currentActiveItem - The current step of the journey
   */
  function handleGoogleRecaptcha(currentActiveItem = 0) {
    const userStatus = document.getElementById('userStatus');
    const recaptchaElement = document.querySelector('[class*="recaptcha_element"]');
    if (recaptchaElement) {
      recaptchaElement.classList.add('hide__default');

      if (IS_SELL_YOUR_CAR_PAGE) {
        if (userStatus && userStatus.value === 'loggedIn') {
          if (currentActiveItem.step === 1) {
            recaptchaElement.classList.add('hide__default');
          }
        } else if (currentActiveItem.step === 2) {
          recaptchaElement.classList.add('hide__default');
        } else if (currentActiveItem.step === 3) {
          recaptchaElement.classList.remove('hide__default');
        }
      } else if (currentActiveItem.step === 4) {
        recaptchaElement.classList.remove('hide__default');
      }
    }
  }

  /**
   * Tick a form nav item based on the provided id.
   * If checked is not provided the item will be checked.
   * @param {string} id The form nav item's id
   * @param {boolean} [checked] If the nav item should be checked
   */
  function updateNavItemTick(id, checked = true) {
    const navItem = document.querySelector(id);
    if (navItem) {
      navItem
        .querySelector('.nav-item__step-number')
        .classList[checked ? 'add' : 'remove']('hide__default');
      navItem
        .querySelector('.nav-item__step-icon')
        .classList[checked ? 'remove' : 'add']('hide__default');
    }
  }

  /**
   * Update the nav item's active state based on the provided id.
   * @param {string} id The form nav item's id
   * @param {boolean} [active] If the nav item should get is-active state
   */
  function updateNavItemActive(id, active = true) {
    const navItem = document.querySelector(id);
    if (navItem) {
      navItem.classList[active ? 'add' : 'remove']('is-active');
    }
  }

  /**
   * Move from the current step based on the provided step. If the current step becomes less than 1
   * from step provided it will diffult to go to step 1
   * @param {number} step The step to move from current step
   *
   * @example
   * goToNavStep(1) // That would move 1 step forward from current step
   * goToNavStep(-1) // That would move 1 step backward from current step
   */
  function goToNavStep(step) {
    // If the step is not provided or is 0 return
    if (!step) return;

    // Calculate the next step if we are going forward or backward
    const nextStepCalc = step > 0 ? 1 : -1;

    let nextStep = currentStep + nextStepCalc;

    if (nextStep < 1) {
      nextStep = 1;
    }

    // Maximum step can be the stored nav items length
    if (nextStep > storedNavItems.length) {
      nextStep = storedNavItems.length;
    }

    const currentActiveItem = getCurrentActiveItem();
    const nextActiveItem = storedNavItems.filter((item) => item.step === nextStep)[0];

    // Pass the current active item
    handleGoogleRecaptcha(nextActiveItem);

    // Check if the next step is forward backward
    switch (true) {
      case nextStep > currentStep:
        // Make the next item active and add a tick to the current nav item
        updateNavItemTick(`.${currentActiveItem.id}`, true);
        updateNavItemActive(`.${nextActiveItem.id}`, true);
        break;
      case nextStep < currentStep:
        // Else make the current item inactive and remove the tick from the next nav item
        updateNavItemActive(`.${currentActiveItem.id}`, false);
        updateNavItemTick(`.${nextActiveItem.id}`, false);
        break;
      default:
        return;
    }

    currentStep = nextStep;

    // Recursive function to update the items 1 by 1 until no step changes are left
    goToNavStep(step - nextStepCalc);
  }

  /**
   * Remove all href links starting from the passed step. This should be called when
   * the current active item is not valid.
   * Ex. If step is 2, step 3 and step 4 items' href link will be removed
   * @param {number} step The step of the item to remove the link
   */
  function removeHrefLinks(step) {
    const nextStep = step + 1;
    const nextStepItem = storedNavItems.filter((item) => item.step === nextStep)[0];

    if (nextStepItem) {
      const anchorLink = document.querySelector(`.${nextStepItem.id} a`);

      if (anchorLink) {
        anchorLink.removeAttribute('href');

        if (IS_MY_CAR_PAGE) {
          anchorLink.onclick = null;
        }
      }

      removeHrefLinks(nextStep);
    }
  }

  /**
   * Set the href link to a link element and handle MyCarPage as well for click handlers
   * @param {HTMLAnchorElement} anchorLink The anchor link
   * @param {string} href The href to set to the anchor link
   */
  function setHrefLink(anchorLink, href) {
    if (anchorLink) {
      anchorLink.setAttribute('href', href);

      if (IS_MY_CAR_PAGE) {
        anchorLink.onclick = (event) => {
          event.preventDefault();
          // eslint-disable-next-line no-use-before-define
          goToFormStep(href.replace(/^#/, ''));
        };
      }
    }
  }

  /**
   * Add an href link to the anchor tag of the nav item
   * @param {FormNavItem} navItem
   */
  function addHrefLink(navItem) {
    if (navItem) {
      const anchorLink = document.querySelector(`.${navItem.id} a`);
      setHrefLink(anchorLink, `#${navItem.paths[0]}`);
    }
  }

  /**
   * Set the button's href and hide class based on provided item
   * @param {HTMLAnchorElement} button The button link to set the href
   * @param {FormNavItem} item The form nav item
   */
  function setStepButtonState(button, item) {
    if (item) {
      setHrefLink(button, `#${item.paths[0]}`);

      button.classList.remove('hide__default');
    } else {
      button.classList.add('hide__default');
    }

    // Hide the back button to return to select a dealership if customer is coming from a VDP
    if (window.vehDetails && getCurrentActiveItem().id === 'js-your-appointment') {
      stepBackButton.classList.add('hide__default');
    }
  }

  /**
   * Update the step buttons state based on the next active item and previous active item
   */
  function updateStepButtonsState() {
    if (stepBackButton && stepContinueButton) {
      let nextActiveItem = getNextActiveItem();
      let previousActiveItem = getPreviousActiveItem();
      if (SMC_COOKIE === 'Combined' && (currentStep === 1 || currentStep === 2)) {
        nextActiveItem = { ...storedNavItems[2] };
      }
      if (SMC_COOKIE === 'Combined' && (currentStep === 3 || currentStep === 4)) {
        previousActiveItem = { ...storedNavItems[0] };
      }
      setStepButtonState(stepContinueButton, nextActiveItem);
      setStepButtonState(stepBackButton, previousActiveItem);

      // eslint-disable-next-line max-len
      // If the next item is not available then we are at the last step and should display the `complete` button
      if (!nextActiveItem) {
        stepCompleteButton.classList.remove('hide__default');
      } else {
        stepCompleteButton.classList.add('hide__default');
      }
    }
  }

  /**
   * Get item from session storage
   * @param {string} key Key to get from session storage
   * @param {string} store Store to get the key from
   */
  function getItemFromSessionStorage(key, store) {
    const sessionStorage = JSON.parse(window.sessionStorage.getItem(store));
    const result = sessionStorage.find((item) => item[key]);
    return result ? result[key] : undefined;
  }

  /**
   * Get item from vehDetails on window object
   * @param {string} key Key to get from vehDetails
   */
  function getItemFromVehDetails(key) {
    return window.vehDetails[key] ? window.vehDetails[key] : '';
  }

  /**
   * Handle how we get the vehicle details
   * @param {string} key Key to get from session storage
   * @param {string} store Store to get the key from
   */
  function handleVehicleDetails(key, store) {
    const isVehicleDetailsInStorage = window.sessionStorage.getItem('_vehicleDetails') || null;
    const isVehDetailsPopulated = window.vehDetails
      ? Object.keys(window.vehDetails).length > 0
      : null;

    if (isVehDetailsPopulated) {
      return getItemFromVehDetails(key);
    }

    if (isVehicleDetailsInStorage) {
      return getItemFromSessionStorage(key, store);
    }

    return '';
  }

  /**
   * Handle dataLayer for appointment booking
   */
  function dataLayerHandler() {
    appointmentDetails.appointmentType = getAppointmentStoreKey('Q647');
    appointmentDetails.vehicleMake = handleVehicleDetails('make', '_vehicleDetails');
    appointmentDetails.vehicleModel = handleVehicleDetails('model', '_vehicleDetails');
    appointmentDetails.vehicleFuelType = handleVehicleDetails('fuelType', '_vehicleDetails');
    appointmentDetails.dealership = getAppointmentStoreKey('Q507');
    appointmentDetails.date = getAppointmentStoreKey('Q641');
    // appointmentDetails.time = getAppointmentStoreKey('Q642');
    appointmentDetails.time = getAppointmentStoreKey('Q672');
    appointmentDetails.userData.email = getAppointmentStoreKey('Q41');
    appointmentDetails.userData.phone_number = getAppointmentStoreKey('Q45');
  }

  /**
   * Update the textContent of the given element with the value of the storeKey.
   *
   * @param {string} selector The element query selector
   * @param {string} storeKey The store key to get content from
   * @param {(content: string) => void} [modifier] The modifier callback to use
   *
   * @example
   * updateElTextContent('.js-apt-type', 'Q647', (content) => content.toLowerCase());
   */
  function updateElTextContent(selector, storeKey, modifier) {
    const elements = document.querySelectorAll(selector);

    if (elements.length) {
      [].forEach.call(elements, (element) => {
        const content = getAppointmentStoreKey(storeKey);

        element.textContent =
          typeof modifier === 'function' ? replaceDealership(modifier(content)) : content;
      });
    }
  }

  function pushDataLayerObject() {
    const currentStep = getCurrentActiveItem();
    const scmCombinedCurrentStep = SMC_COOKIE ? currentStep.step === 1 : currentStep.step === 4;
    const event = scmCombinedCurrentStep ? 'appointmentBookingComplete' : 'appointmentBookingApp';
    if (scmCombinedCurrentStep) {
      delete appointmentDetails.step;
    } else {
      appointmentDetails.step = currentStep.step + 1;
    }
    window.dataLayer.push({
      event,
      appointmentDetails: [{ ...appointmentDetails }],
    });
  }

  /**
   * Fetch the dealerships using the ajax_dealer_services API
   * @param {{ startPos?: number, postcode?: string,
   * facilities?: string, franchise?: string, }} params
   */
  function fetchDealerships(params = SEARCH_CURRENT_PARAMS) {
    const key = JSON.stringify(params);
    const storedItem = getAppointmentStoreKey(key);

    if (storedItem) {
      return Promise.resolve(storedItem);
    }

    // If there isn't a value for the franchise, default
    // it to DEALER
    if (SEARCH_CURRENT_PARAMS.franchise === '') {
      SEARCH_CURRENT_PARAMS.franchise = 'DEALER';
    }

    // If the vehicle is a bike/van and the user wants to book an
    // appointment, lock the dealerships to vehicle type
    if (IS_SELL_YOUR_CAR_PAGE) {
      // Disabling this code from running on vertumotors as that is
      // how it has been historically until further clarification
      if (!window.location.href.includes('value-my-car')) {
        const vehicleDetailsSession = JSON.parse(window.sessionStorage.getItem('_vehicleDetails'));

        if (vehicleDetailsSession) {
          const vehicleDetails = vehicleDetailsSession.find((item) => item?.vehType);

          if (vehicleDetails) {
            const { vehType } = vehicleDetails;

            SEARCH_CURRENT_PARAMS.facilities = 'USEDCAR'; // Default value
            SEARCH_CURRENT_PARAMS.SMCOnly = 'YES';

            if (vehType === 'bike') {
              SEARCH_CURRENT_PARAMS.brandOnly = '';
              SEARCH_CURRENT_PARAMS.facilities = 'BIKE';
            } else if (vehType === 'van') {
              SEARCH_CURRENT_PARAMS.facilities = 'VAN';
            }
          }
        }
      }
    }

    return axios
      .get(SEARCH_ENDPOINT_URL, {
        params,
      })
      .then((res) => {
        if (res.data && res.data.dealerResponse) {
          setAppointmentStoreKey(key, res.data.dealerResponse);
          // Set the appointment slots to the session
          if (
            res.data.dealerResponse.dealerDtl.length > 0 &&
            res.data.dealerResponse.dealerDtl[0].dlrAppointmentTimes
          ) {
            window.sessionStorage.setItem(
              APT_SLOT_STORE_KEY,
              JSON.stringify(res.data.dealerResponse.dealerDtl[0].dlrAppointmentTimes),
            );
          }
          return res.data.dealerResponse;
        }
        return '';
      });
  }

  /**
   * Checks to see if the dealership is closed or not,
   * and if it is, it disables the physical-appointment option
   */
  function manufacturerOpenState() {
    const dealershipSummaryInput = document.getElementById('physical-appointment');
    const dealershipSummaryLabel = document.getElementById('physical-appointment-label');
    const data = JSON.parse(window.sessionStorage.getItem('_appointmentStore'));
    SEARCH_CURRENT_PARAMS.dlrname = data.Q507;

    fetchDealerships().then((dlr) => {
      if (data.Q507 === dlr.custDlrName && dlr.dealerDtl[0]) {
        window.sessionStorage.setItem(
          APT_SLOT_STORE_KEY,
          JSON.stringify(dlr.dealerDtl[0].dlrAppointmentTimes),
        );
      }

      if (dlr.dealerDtl.dlr_message && dlr.dealerDtl.dlr_message !== '') {
        dealershipSummaryInput.disabled = true;
        dealershipSummaryLabel.classList.add('summary-card--is-disabled');
      }
    });
    SEARCH_DEFAULT_PARAMS.dlrname = '';
  }

  /**
   * Change handler of the form to validate the current item in view so that buttons are accessible
   */
  function formChangeHandler() {
    // get dealership name if it exists
    const appointmentStoreKey = getAppointmentStoreKey('Q507');
    const currentItem = getCurrentActiveItem();
    const isValidItem = currentItem.isValid();
    const method = isValidItem ? 'remove' : 'add';
    dataLayerHandler(currentItem);

    if (!isValidItem) {
      removeHrefLinks(currentStep);
    }

    if (currentStep === 1) {
      updateElTextContent('.js-apt-type', 'Q647', (content) => content.toLowerCase());
    }

    if (currentStep === 2 && !appointmentStoreKey) {
      stepContinueButton.setAttribute('disabled', 'disabled');
    } else {
      stepContinueButton.removeAttribute('disabled');
    }

    // Crazy Egg Exit Survey for date and time step
    const crazyEggExitSurvey = window.crazyeggExitSurvey;

    if (crazyEggExitSurvey && currentStep === 2) {
      crazyEggExitSurvey.addSurvey('e6addd77-6d65-444e-b599-356b34f93bb7');
    } else if (crazyEggExitSurvey) {
      crazyEggExitSurvey.removeSurvey();
    }

    // if (currentStep === 3) {
    // const dropdownOptions = document.getElementById('Q642');
    // const amOption = dropdownOptions[1];
    // const dateContainer = document.querySelector('.dayContainer');
    // const todaysDate = dateContainer.querySelector('.today');

    // if (amOption.selected) {
    //   if (todaysDate && todaysDate.classList.contains('selected')) {
    //     dropdownOptions.value = 'PM';
    //   } else {
    //     dropdownOptions.value = 'AM';
    //   }
    // }

    // if (todaysDate && todaysDate.classList.contains('selected')) {
    //   amOption.setAttribute('disabled', '');
    // } else {
    //   amOption.removeAttribute('disabled', '');
    // }
    // }

    stepContinueButton.classList[method]('disabled');

    if (currentItem.step === storedNavItems.length) {
      stepCompleteButton.classList[method]('disabled');
    }
  }

  /**
   * Go to form step based on the provided path
   * @param {string} path The path to go to
   */
  function goToFormStep(path) {
    const hashReg = new RegExp(`${path}$`, 'i');
    const currentItem = getCurrentActiveItem();
    const nextItem = storedNavItems.filter(
      (item) => item.paths.filter((p) => hashReg.test(p)).length,
    )[0];
    const dateTime = storedNavItems.filter(
      (item) => item.formContainer === 'js-date-time-block',
    )[0];
    if (!nextItem || !currentItem) {
      return;
    }

    const currentScreen = document.querySelector(`.${currentItem.formContainer}`);
    const smcCombinedStep = document.querySelector(`.${dateTime.formContainer}`);
    const nextScreen = document.querySelector(`.${nextItem.formContainer}`);

    addHrefLink(currentItem);
    addHrefLink(nextItem);

    goToNavStep(nextItem.step - currentStep);

    if (currentScreen && nextScreen) {
      if (nextItem.step === 1 && SMC_COOKIE === 'Combined') {
        smcCombinedStep.classList.remove('hide__default');
      } else {
        smcCombinedStep.classList.add('hide__default');
      }
      currentScreen.classList.add('hide__default');
      nextScreen.classList.remove('hide__default');
    }

    updateStepButtonsState();

    // Handle the new form in view
    formChangeHandler();
  }

  const dealershipBlock = document.querySelector('.js-dealership-block');
  const appointmentBlock = document.querySelector('.js-appointment-block');

  // Hide appointment blocks based on the needed order
  if (appBookChangeStageOrder === true && dealershipBlock && appointmentBlock) {
    dealershipBlock.classList.remove('hide__default');
    appointmentBlock.classList.add('hide__default');
  }

  /**
   * Create a form nav item element from the provided form nav item
   * @param {FormNavItem} item The form nav item to build
   */
  function createFormNavItem(item) {
    const { isActive, isTicked, id, title, step } = item;
    const toggleFormDisplay = isTicked ? '' : ' hide__default';
    const toggleSpanDisplay = isTicked ? ' hide__default' : '';
    const itemElement = document.createElement('li');
    itemElement.className = `form-nav__item${isActive || isTicked ? ' is-active' : ''} ${id}`;

    itemElement.innerHTML = `
              <a>
                <div class="nav-item__step">
                  <i class="far fa-check nav-item__step-icon${toggleFormDisplay}" style="font-size: 1.2em;"></i>
                  <span class="nav-item__step-number${toggleSpanDisplay}">${step}</span>
                </div>
                <div class="nav-item__title">
                  ${replaceDealership(title)}
                </div>
              </a>
        `;
    return itemElement;
  }

  /**
   * Render the form nav items in the given container with provided form items
   * @param {object} options The options object
   * @param {FormNavItem[]} [options.items] The form nav items
   * @param {Element | string} [options.container] The container to render the form nav
   *
   */
  function renderFormNavItems({ items, container }) {
    storedNavItems = [...items];

    let containerElement;

    if (typeof container === 'string') {
      containerElement = document.querySelector(container);
    } else {
      containerElement = container;
    }

    if (!containerElement) {
      window.vm.debug.error(`Container element ${container} was not found on the page`);
      return;
    }

    // Clear all it's content, in case we want to rerender it
    containerElement.textContent = '';

    const itemsList = document.createDocumentFragment();
    let isTicked = false;

    // Sort the nav items based on the step position.
    //  Sort in descending order to get last item first
    // We do that in order to define if the items should be checked when an active item was found
    items
      .sort((a, b) => b.step - a.step)
      .forEach((item) => {
        item.isTicked = isTicked;
        item.isActive = isActiveStep(item, window.location.hash);

        const itemElement = createFormNavItem(item);
        itemsList.insertBefore(itemElement, itemsList.firstChild);

        if (!isTicked && item.isActive) {
          isTicked = true;
        }
      });

    const itemsContainer = document.createElement('ul');
    itemsContainer.className = 'form-nav form-nav--small';
    itemsContainer.style = '-webkit-justify-content: center; justify-content: center;';

    itemsContainer.appendChild(itemsList);

    containerElement.appendChild(itemsContainer);
  }

  /**
   * Set a value to an element and trigger the event to update the view for the form-utilities.
   * Save the element's value in the appointment
   * store to be used from other parts of the application.
   * @param {HTMLInputElement | HTMLSelectElement} element
   * @param {string} value The value to set
   * @param {string} event the event to fire
   */
  function setElementValue(element, value, event = 'blur') {
    if (element) {
      element.value = value;

      setAppointmentStoreKey(element.name, value);

      // Fire an event for the form utilities to update the classes of the inputs
      if ('fireEvent' in element) {
        // IE
        element.fireEvent(`on${event}`);
      } else if (typeof window.Event === 'function') {
        // Modern browsers
        element.dispatchEvent(new Event(event));
      } else {
        // Older browsers
        const evObj = document.createEvent('Event');
        evObj.initEvent(event, true, true);
        element.dispatchEvent(evObj);
      }
    }
  }

  /**
   * Create a summary card option based on the provided card options
   * @param {Object} cardOptions The card options for to be used
   * @param {string} [cardOptions.id] The input's id for the option
   * @param {string} [cardOptions.name] The input's name
   * @param {string} [cardOptions.value] The input's value
   * @param {string} [cardOptions.svg] The input's svg id for the <use> element
   * @param {string} [cardOptions.title] The input's title.
   * If title is not provided the value is going to be used
   * @param {string} [cardOptions.subtitle] The input's subtitle
   * @param {boolean} [cardOptions.disabled] If the option should be disabled
   */
  function createSummaryCardOption(cardOptions) {
    const summaryTitle =
      replaceDealership(cardOptions.title) || replaceDealership(cardOptions.value);
    const summaryCard = document.createElement('div');
    summaryCard.classList.add('summary-card__wrapper');

    summaryCard.innerHTML = `
              <input class="summary-card__radio-btn"
               type="radio"
                id="${cardOptions.id}" 
                name="${cardOptions.name}" 
                value="${cardOptions.value}" 
                autocomplete="off" 
                ${cardOptions.disabled ? 'disabled' : ''}>
              <label for="${cardOptions.id}" 
              id="${cardOptions.id}-label" 
              class="summary-card summary-card--full-height summary-card__btn 
              ${cardOptions.disabled ? 'summary-card--is-disabled' : ''}">
                  <div class="summary-card__content">
                      <svg aria-hidden="true" focusable="false" class="summary-card__icon summary-card__icon--large">
                          <use xlink:href="#${cardOptions.svg}"></use>
                      </svg>
                      <div class="summary-card__title font--bold">
                      ${summaryTitle}
                      </div>
                      <span class="hide--if-on-test-drive">
                          ${replaceDealership(cardOptions.subtitle)}
                      </span>
                  </div>
              </label>
            `;

    return summaryCard;
  }

  /**
   *  Render the appointment summary cards
   */
  function renderAppointmentSummaryCards() {
    const appointmentTypeSelect = document.querySelector('#Q647');
    const appointmentOptionsContainer = document.querySelector('.js-appointment-options');

    if (appointmentTypeSelect && appointmentOptionsContainer && window.appointmentTypeOptions) {
      const fragmentContainer = document.createDocumentFragment();

      // Revert back after dealerships are open again
      // eslint-disable-next-line max-len
      // window.appointmentTypeOptions.forEach(type => fragmentContainer.appendChild(createSummaryCardOption(type)));

      // Temporary solution until dealerships open
      window.appointmentTypeOptions.forEach((type) => {
        const summaryCard = createSummaryCardOption(type);
        if (window.physicalOpeningDate) {
          const now = new Date().getTime();
          const openingDate = new Date(window.physicalOpeningDate).getTime();
          if (now < openingDate) {
            summaryCard.addEventListener('change', () => {
              if (type.id === 'physical-appointment') {
                window.datePickerInstance.set('minDate', window.physicalOpeningDate);
              }
            });
          }
        }
        return fragmentContainer.appendChild(summaryCard);
      });

      appointmentOptionsContainer.textContent = '';
      appointmentOptionsContainer.appendChild(fragmentContainer);

      const aptTypeContainer = appointmentTypeSelect.parentElement;
      aptTypeContainer.parentElement.removeChild(aptTypeContainer);
    }
  }

  /**
   * Changes the message displayed in step 2 depending on the type of appointment
   */
  // function changeDealershipMessage() {
  //   const dealerMessage = document.querySelector('.js-apt-dealer-msg');
  //   const appointmentTile = document.querySelector('.js-appointment-options');

  //   document.addEventListener('click', () => {
  //     if (window.location.href.includes('book-an-appointment')) {
  //       if (appointmentTile.children[0].children[0].checked) {
  // eslint-disable-next-line max-len
  //         dealerMessage.innerText = 'Which dealership would you like to have your video call appointment with?';
  //       } else if (appointmentTile.children[1].children[0].checked) {
  // eslint-disable-next-line max-len
  //         dealerMessage.innerText = 'Which dealership would you like to have your dealership appointment with?';
  //       } else {
  // eslint-disable-next-line max-len
  //         dealerMessage.innerText = 'Which dealership would you like to have your appointment with?';
  //       }
  //     }
  //   });
  // }

  // changeDealershipMessage();

  /**
   * The handler for the hash change to handle the routing between the steps
   */
  function hashChangeHandler() {
    goToFormStep(window.location.hash.substr(1));
  }

  function getFinanceSessionObject() {
    const financeSessionObject = window.sessionStorage.getItem('_financeDataLayer');
    if (financeSessionObject) {
      const financeSessionObjectParsed = JSON.parse(financeSessionObject);
      window.dataLayer.push({
        financeSessionObjectParsed,
      });
    }
  }

  function checkPageLocationAndReturnCorrectValue() {
    const urlLocation = window.location.href;

    switch (true) {
      case urlLocation.includes('new-car'):
        return 'NEWCAR';
      case urlLocation.includes('used-car'):
        return 'USEDCAR ';
      default:
        return '';
    }
  }

  function initSearchParams() {
    const initParams = {
      brandOnly: 'yes',
      franchise: 'DEALER',
    };
    switch (appointmentDetails.vehicleType) {
      case 'new-appointment':
        initParams.facilities = IS_MOTORCYCLE_PAGE ? 'BIKE' : 'NEWCAR';
        break;
      case 'used-appointment':
        initParams.facilities = IS_MOTORCYCLE_PAGE ? 'BIKE' : 'USEDCAR';
        break;
      case 'van-appointment':
        initParams.facilities = 'VAN';
        break;
      case 'motability-appointment':
        initParams.facilities = 'MOTAB';
        break;
      default:
        initParams.facilities = checkPageLocationAndReturnCorrectValue();
        break;
    }

    if (IS_CAMPAIGN_FORM && mktApptCampaign.mktApptCampaignId) {
      initParams.mktApptId = mktApptCampaign.mktApptCampaignId;
    }

    Object.assign(SEARCH_CURRENT_PARAMS, initParams);
  }

  function initAppointmentMiscParams() {
    const campaignCodeParam = document.querySelector('input[name="Q639"]');
    const sellMyCarEnquiryParam = document.querySelector('input[name="Q657"]');
    const appointmentTypeSelect = document.querySelector('#Q647');

    if ((HAS_CAMPAIGN_CODE || IS_JULY_CAMPAIGN_URL) && campaignCodeParam) {
      campaignCodeParam.value = urlSearchParams.get('utm_campaign')
        ? urlSearchParams.get('utm_campaign')
        : 'Unknown';
    }

    // Sets sell my car parameters for appointment forms outside of sell my car angular app
    if (
      IS_SELL_YOUR_CAR_PAGE &&
      !IS_SELL_YOUR_CAR_APP &&
      sellMyCarEnquiryParam &&
      appointmentTypeSelect
    ) {
      sellMyCarEnquiryParam.value = 'YES';
      setElementValue(appointmentTypeSelect, 'Physical appointment');
    }
  }

  /**
   * Initialize the form when it is on a used VDP.
   * Prepopulate the select dropdown with the vehicle's
   * dealership location and add a booking comment regarding the specific vehicle.
   *
   * Task: https://app.asana.com/0/1199552019689709/1199524388481655/f
   */
  function initVehicleDetails() {
    // eslint-disable-next-line prefer-destructuring
    const vehDetails = window.vehDetails;

    if (vehDetails && vehDetails.location && vehDetails.location !== '#DEALERSHIP_LOCATION#') {
      const dealerSelect = document.querySelector('#Q507');

      if (dealerSelect) {
        setElementValue(dealerSelect, vehDetails.location);
      }

      const bookingComment = document.querySelector('#Q59');
      const bookingCommentText = `I would like to discuss ${vehDetails.make} ${vehDetails.model} ${vehDetails.desc}.`;
      setElementValue(bookingComment, bookingCommentText);
    }
  }

  function initPartExDetails() {
    const data = JSON.parse(window.sessionStorage.getItem('_partExAppointment'));

    if (data) {
      const forename = document.querySelector('#Q2');
      setElementValue(forename, data.forename);

      const surname = document.querySelector('#Q3');
      setElementValue(surname, data.surname);

      const bookingComment = document.querySelector('#Q59');
      setElementValue(bookingComment, data.reason);
    }
  }

  /**
   * Load the dealer name from the DEALER_COOKIE that is used when the user
   * navigates from the dealer home page to appointment form.
   */
  function loadDealerFromCookie() {
    const findADealerMatch =
      window.location.pathname.match(FIND_A_DEALER_REG) ||
      window.location.pathname.match(OUR_LOCATIONS_REG);
    const cookieDealer = window.Cookie.get(DEALER_COOKIE);
    const cookieDealerMatch =
      cookieDealer.match(FIND_A_DEALER_COOKIE_REG) || cookieDealer.match(OUR_LOCATIONS_COOKIE_REG);

    // eslint-disable-next-line no-nested-ternary
    const dealer = findADealerMatch
      ? findADealerMatch[1]
      : cookieDealerMatch
        ? cookieDealerMatch[1]
        : null;

    if (dealer) {
      const dealerSelect = document.querySelector('#Q507');

      if (dealerSelect) {
        // Words that shoud be upper cased
        const upperCasedWords = ['pdi', 'cupra', 'ds', 'iveco', 'seat', 'skoda', 'bmw'];

        // Get the default dealership from the regex match
        let defaultDealer = dealer
          .split('-')
          // eslint-disable-next-line no-confusing-arrow
          .map((s) =>
            upperCasedWords.includes(s) ? s.toUpperCase() : s.charAt(0).toUpperCase() + s.substr(1),
          )
          .join(' ');

        defaultDealer = defaultDealer.replace('Mercedes Benz', 'Mercedes-Benz');
        setElementValue(dealerSelect, defaultDealer);
      }
    }
  }

  /**
   * Convert the dealer select element to an input element for the new nearest dealerships
   * layout.
   * @param {HTMLFormElement} appointmentForm The appointment form element
   */
  function convertDealerSelectToInput(appointmentForm) {
    const dealerSelect = appointmentForm.querySelector('#Q507');
    const { name, id, className, required, style, value } = dealerSelect;

    const input = document.createElement('input');
    input.name = name;
    input.id = id;
    input.className = className;
    input.required = required;
    input.style = style;
    input.value = value;

    dealerSelect.insertAdjacentElement('afterend', input);
    dealerSelect.parentElement.removeChild(dealerSelect);
    nearestDealershipsElements.dealerDropdownSelect = input;

    // Load the dealer from cookie after the change in case that the dealer was not in the options
    loadDealerFromCookie();
  }

  /**
   * Update the manufacturer select options if the manufacturer has not been set
   * @param {{ manufacturer_code: string, manufacturer_label: string,
   *  manufacturer_value: number }} manFacets
   */
  function updateManufacturerOptions(manFacets) {
    if (SEARCH_CURRENT_PARAMS.franchise !== 'DEALER') {
      return;
    }

    if (nearestDealershipsElements.manufacturerSelect) {
      const firstOption = nearestDealershipsElements.manufacturerSelect.options[0];
      clearElementContent(nearestDealershipsElements.manufacturerSelect);

      nearestDealershipsElements.manufacturerSelect.add(firstOption);

      if (manFacets) {
        manFacets.forEach((man) => {
          const opt = new Option(
            `${man.manufacturer_label} (${man.manufacturer_value})`,
            man.manufacturer_code,
          );
          nearestDealershipsElements.manufacturerSelect.add(opt);
        });
      }
    }
  }

  /**
   * Builds the img container for the given img source.
   * @param {string} imgSrc
   */
  function getDealershipImgContainer(imgSrc) {
    if (imgSrc) {
      const imgContainer = document.createElement('div');
      imgContainer.classList.add('tile-img__container');

      const img = document.createElement('div');
      img.classList.add('tile-img--background');
      img.style.backgroundImage = `url(${imgSrc})`;

      imgContainer.appendChild(img);

      return imgContainer;
    }
    return '';
  }

  /**
   * Builds the tile body for the given dealership.
   * @param {*} dlr
   */
  function getDealershipBody(dlr) {
    const tileBody = document.createElement('div');
    tileBody.classList.add('tile-body');

    // Inner body containing dealership name/description + address
    const inner = document.createElement('div');

    const title = document.createElement('h3');
    title.innerHTML = dlr.dlrDsc;
    title.classList.add('tile-text__headline', 'heading--grouped');
    inner.appendChild(title);

    const address = document.createElement('p');
    address.classList.add('tile-text__regular--light', 'tile-text--grouped');
    address.innerHTML = dlr.dlr_addressfull_nobr;
    inner.appendChild(address);

    tileBody.appendChild(inner);

    // Distance
    if (dlr.dlrDistanceMiles !== 999) {
      const icon = `<svg xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink"
                id="Layer_1" version="1.1" viewBox="0 0 24 24" x="0px" xmlns="http://www.w3.org/2000/svg" y="0px"
                class="svg-icon">
                  <g transform="translate(-2)">
                    <path d="M21,10c0,7-9,13-9,13S3,17,3,10a9,9,0,1,1,18,0Z" fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                    <circle cx="3" cy="3" r="3" transform="translate(9 7)" fill="white" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></circle>
                  </g>
                </svg>`;

      const dist = document.createElement('p');
      dist.classList.add(
        'tile-text--with-icon-inline',
        'text--primary',
        'font--bold',
        'tile-text--grouped',
        'text-size--smaller',
        'padding-top-5',
      );
      dist.innerHTML = `${icon} ${dlr.dlrDistanceMiles} mile${
        dlr.dlrDistanceMiles > 0 ? 's' : ''
      } away`;

      tileBody.appendChild(dist);
    }

    return tileBody;
  }

  /**
   * Build dealership tile footer.
   * @param {*} dlr
   */
  function getDealershipFooter(dlr) {
    const isSelected =
      dlr.dlrDsc.toUpperCase() ===
      nearestDealershipsElements.dealerDropdownSelect.value.toUpperCase();

    const actionContainer = document.createElement('div');
    actionContainer.classList.add('tile__footer');
    const selectBtn = document.createElement('button');
    selectBtn.type = 'button';
    selectBtn.classList.add(
      'btn',
      isSelected ? 'btn--primary' : 'btn--outline',
      'tile-btn',
      'js-select-dealership',
    );
    Object.assign(selectBtn.dataset, { dlrDsc: `${dlr.dlrDsc}` });
    selectBtn.innerHTML = isSelected ? 'Selected' : 'Select';
    actionContainer.appendChild(selectBtn);

    if (isSelected) {
      selectedDealership = selectBtn;
    }

    return actionContainer;
  }

  /**
   * Create a dealership tile for the geolocator.
   * @param {*} dlr
   */
  function createDealershipTile(dlr) {
    const tile = document.createElement('li');
    tile.classList.add(
      'tile',
      'tile--with-border-radius',
      'tile--with-shadow',
      'background--white',
    );

    tile.appendChild(getDealershipImgContainer(dlr.dlr_img));
    tile.appendChild(getDealershipBody(dlr));
    tile.appendChild(getDealershipFooter(dlr));

    return tile;
  }

  /**
   * Render the nearest dealerships list
   * @param {boolean} [clearList] If the dealership list should be cleared
   */
  function renderNearestDealerships(clearList) {
    return fetchDealerships().then((res) => {
      updateManufacturerOptions(res.dealerFacetFields.manufacturer);

      // Build the list
      const fragment = document.createDocumentFragment();

      res.dealerDtl.forEach((dlr) => {
        fragment.appendChild(createDealershipTile(dlr));
      });

      const listContainer = nearestDealershipsElements.nearestDealershipsContainer.querySelector(
        '.js-apt-nearest-dealership-list',
      );

      if (clearList) {
        clearElementContent(listContainer);
        nearestDealershipsElements.showMoreButton.classList.remove('hide__default');
      }

      listContainer.appendChild(fragment);

      nearestDealershipsElements.nearestDealershipsContainer.classList.remove('hide__default');

      // If no result where found then hide the show more button
      if (res.lastResult === 0) {
        nearestDealershipsElements.showMoreButton.classList.add('hide__default');
      }

      nearestDealershipsElements.showAllButton.classList.add('hide__default');

      formChangeHandler();

      return res;
    });
  }

  /**
   * Handle the postcode input event when the input changes.
   * @param {CustomEvent<{ postcode?: string }>} event The custom event fired
   */
  function handlePostcodeInput(event) {
    const postcode = event.detail && event.detail.postcode ? event.detail.postcode : '';

    SEARCH_CURRENT_PARAMS.startPos = 0;
    SEARCH_CURRENT_PARAMS.numRows = 3;
    SEARCH_CURRENT_PARAMS.dlrname = '';

    SEARCH_CURRENT_PARAMS.sort = postcode ? 'Distance' : '';

    // Remove any spaces and convert to lowercase for better caching
    SEARCH_CURRENT_PARAMS.postcode = postcode.replace(/\s+/, '').toLowerCase();

    // If there is an event, add the marketing ID to the params
    if (IS_CAMPAIGN_FORM && mktApptCampaign.mktApptCampaignId) {
      SEARCH_CURRENT_PARAMS.mktApptId = mktApptCampaign.mktApptCampaignId;
    }

    renderNearestDealerships(true);

    setElementValue(event.target, postcode);
  }

  function handlePostcodeNotFound(event) {
    window.validator.showErrorMessage(event.target, 'required');
    event.target.parentElement.querySelector('.form__message').textContent =
      "Sorry, we couldn't find your postcode. Please input manually or filter by manufacturer.";
    renderNearestDealerships(true);
  }

  /**
   * Handle the show more dealerships action to get more dealers
   */
  function handleShowMoreDealers() {
    SEARCH_CURRENT_PARAMS.startPos += SEARCH_CURRENT_PARAMS.numRows;
    SEARCH_CURRENT_PARAMS.numRows = 10;

    renderNearestDealerships();
  }

  /**
   * Handle the manufacturer change event when the select options change
   * @param {Event} event
   */
  function handleManufacturerChange(event) {
    const { value } = event.target;
    SEARCH_CURRENT_PARAMS.numRows = 3;
    SEARCH_CURRENT_PARAMS.startPos = 0;
    SEARCH_CURRENT_PARAMS.franchise = value;
    SEARCH_CURRENT_PARAMS.dlrname = '';

    renderNearestDealerships(true);
  }

  function scrollToSelectedDealershipTile() {
    const selectedDealershipButton = document.querySelector('.selected__dealership');
    let selectedDealershipTile;

    if (selectedDealershipButton) {
      selectedDealershipTile = selectedDealershipButton.parentElement.parentElement;
    }

    const offset = document.querySelector('.js-site-primary-nav').offsetHeight + 20;
    smoothScroll(selectedDealershipTile, offset);
  }

  /**
   * Handles the selections of dealerships.
   * @param {Event} event
   */
  function handleDealershipClick(event) {
    if (
      event.target.matches(selectDealershipBtn) &&
      nearestDealershipsElements.dealerDropdownSelect.value !== event.target.dataset.dlrDsc
    ) {
      if (selectedDealership) {
        selectedDealership.innerHTML = 'Select';
        selectedDealership.classList.add('btn--outline');
        selectedDealership.classList.remove('selected__dealership');
        selectedDealership.classList.remove('btn--primary');
      }
      selectedDealership = event.target;

      setElementValue(
        nearestDealershipsElements.dealerDropdownSelect,
        selectedDealership.dataset.dlrDsc,
      );

      selectedDealership.innerHTML = 'Selected';
      selectedDealership.classList.add('btn--primary');
      selectedDealership.classList.add('selected__dealership');
      selectedDealership.classList.remove('btn--outline');
      const appointmentStoreKey = JSON.parse(window.sessionStorage.getItem('_appointmentStore'));

      if (
        SMC_COOKIE === 'Combined' &&
        appointmentStoreKey !== null &&
        typeof appointmentStoreKey === 'object'
      ) {
        pushDataLayerObject();
        manufacturerOpenState();
      }
      scrollToSelectedDealershipTile();

      formChangeHandler();
    }
  }

  /**
   * Initialize the nearest dealership functionality using ajax_dealer_services API
   * @param {HTMLFormElement} appointmentForm The appointment form
   */
  function initNearestDealership(appointmentForm) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in nearestDealershipsElements) {
      if (Object.hasOwnProperty.call(nearestDealershipsElements, key)) {
        nearestDealershipsElements[key] = document.querySelector(nearestDealershipsElements[key]);
      }
    }

    const {
      geolocatorContainer,
      postcodeInput,
      showMoreButton,
      showAllButton,
      manufacturerSelect,
      nearestDealershipsContainer,
    } = nearestDealershipsElements;

    if (geolocatorContainer && postcodeInput && typeof window.postcodeGeocoder !== 'undefined') {
      convertDealerSelectToInput(appointmentForm);

      // Initialize the geocoder and add the appropriate event listeners
      window.postcodeGeocoder.init(geolocatorContainer, postcodeInput);

      postcodeInput.addEventListener('postcodeInput', handlePostcodeInput, false);

      postcodeInput.addEventListener('postcodeNotFound', handlePostcodeNotFound, false);

      showMoreButton.addEventListener('click', handleShowMoreDealers, false);
      showAllButton.addEventListener('click', renderNearestDealerships, false);

      manufacturerSelect.addEventListener('change', handleManufacturerChange, false);

      nearestDealershipsContainer.addEventListener('click', handleDealershipClick, false);

      // If the user comes from a VDP, preselect the dealer and skip to next step
      if (window.vehDetails) {
        const { vehDetails } = window;
        const dealerSelect = document.querySelector('#Q507');
        setElementValue(dealerSelect, vehDetails.location);
        SEARCH_CURRENT_PARAMS.dlrname = dealerSelect.value;
        SEARCH_CURRENT_PARAMS.brandOnly = '';
        renderNearestDealerships(true);
        formChangeHandler();
        dealershipBlock.classList.add('hide__default');
        appointmentBlock.classList.remove('hide__default');

        goToNavStep(1);

        if (
          !document.querySelector('#physical-appointment').checked &&
          !document.querySelector('#virtual-appointment').checked
        ) {
          document.querySelector('.js-apt-continue-btn').classList.add('disabled');
        }
      }

      // If the user comes from a New Car VDP, preselect the make
      const { vehManufacturer } = window;

      if (vehManufacturer) {
        if (!vehManufacturer.make.includes('#MAKE#')) {
          // Hide manufacturer dropdown when it's pre selected for
          // new vehicle booking to prevent showing empty one
          const manufacturerDropdown = document.querySelector(
            '.js-apt-nearest-dealership #manufacturer',
          );

          if (manufacturerDropdown) manufacturerDropdown.classList.add('hide__default');
          // Set facilities to Van when on new van appointment booking
          if (window.location.pathname.includes('new-van-deals')) {
            SEARCH_CURRENT_PARAMS.facilities = 'VAN';
          } else if (window.location.pathname.includes('motability')) {
            SEARCH_CURRENT_PARAMS.facilities = 'MOTAB';
          }
          // Check if it's Mercedes AMG and repalce with Benz as they share dealerships
          SEARCH_CURRENT_PARAMS.franchise =
            vehManufacturer.make === 'Mercedes-AMG' ? 'Mercedes-Benz' : vehManufacturer.make;
          SEARCH_CURRENT_PARAMS.brandOnly = '';
          renderNearestDealerships(true);
          formChangeHandler();
        }
      }

      const { landingPage } = window;
      if (landingPage) {
        const manufacturerDropdown = document.querySelector(
          '.js-apt-nearest-dealership #manufacturer',
        );
        if (manufacturerDropdown) manufacturerDropdown.classList.add('hide__default');
        SEARCH_CURRENT_PARAMS.franchise = landingPage;
        renderNearestDealerships(true);
        formChangeHandler();
      }

      // If the dealer select has been set we need to render the selected dealer
      if (nearestDealershipsElements.dealerDropdownSelect.value) {
        SEARCH_CURRENT_PARAMS.dlrname = nearestDealershipsElements.dealerDropdownSelect.value;
        renderNearestDealerships(true);
        formChangeHandler();
      }
    } else {
      loadDealerFromCookie();
      // Default to simple dealership selection.
      try {
        nearestDealershipsElements.geolocatorContainer.classList.add('hide__default');
        nearestDealershipsElements.showAllButton.classList.add('hide__default');
      } catch (error) {
        console.warn(error);
      } finally {
        nearestDealershipsElements.dealerDropdownSelect.parentElement.classList.remove(
          'hide__default',
        );
      }
    }
  }

  /**
   * Initialize the appointment form. Select the step buttons and add the event handlers for
   * the step navigation and form changes.
   * @param {HTMLFormElement} appointmentForm
   */
  function initAppointmentForm(appointmentForm) {
    stepBackButton = document.querySelector('.js-apt-back-btn');
    stepContinueButton = document.querySelector('.js-apt-continue-btn');
    stepCompleteButton = document.querySelector('.js-apt-complete-btn');
    appointmentDetails.vehicleType = appointmentForm.getAttribute('data-form-type');

    const smcIcons = document.querySelector('.js-sell-my-car-icons');

    if (IS_SELL_YOUR_CAR_PAGE) {
      if (smcIcons) {
        smcIcons.classList.remove('hide__default');
      }
    }

    if (!stepBackButton || !stepContinueButton || !stepCompleteButton) {
      window.vm.debug.error('Navigation button were not found on the page');
      return;
    }

    if (IS_SELL_YOUR_CAR_PAGE) {
      stepBackButton.addEventListener('click', () => {
        if (window.location.href.includes('date-and-time')) {
          window.location.href = window.location.href.replace('date-and-time', '');
        }
      });
    }

    const appointmentFormH2 = appointmentForm.parentElement.querySelector('h2');

    appointmentFormH2.parentElement.removeChild(appointmentFormH2);

    stepContinueButton.addEventListener('click', () => {
      pushDataLayerObject();
      manufacturerOpenState();
    });

    stepCompleteButton.addEventListener('click', pushDataLayerObject);

    // If we are on the form page clear the store
    clearAppointmentStore();

    if (!IS_SELL_YOUR_CAR_PAGE) {
      renderAppointmentSummaryCards();
    }

    initVehicleDetails();
    initPartExDetails();
    initSearchParams();
    initNearestDealership(appointmentForm);
    initAppointmentMiscParams();

    updateStepButtonsState();

    document.querySelector('#form_97').addEventListener('change', formChangeHandler, false);
    document.querySelector('#form_97 textarea').addEventListener('keyup', formChangeHandler, false);

    // My car angular app uses router hash strategy which conflicts with hashChangeHandler
    if (!IS_MY_CAR_PAGE) {
      window.addEventListener('hashchange', hashChangeHandler, false);
    }
  }

  /**
   * Initialize the thank you page
   */
  function initThankYouPage() {
    goToNavStep(storedNavItems.length);
    const currentItem = getCurrentActiveItem();

    initAppointmentStore();

    updateNavItemTick(`.${currentItem.id}`, true);
    const itemTitle = document.querySelector(`.${currentItem.id} .nav-item__title`);

    if (!itemTitle) {
      window.vm.debug.error('Thank you page cannot be initialized, nav items are missing');
      return;
    }

    itemTitle.textContent = 'Confirmation';

    const billboard = document.querySelector('.billboard__container');
    if (billboard) {
      billboard.parentElement.removeChild(billboard);
    }

    updateElTextContent('.js-apt-type', 'Q647', (content) => content.toLowerCase());
    updateElTextContent('.js-apt-dealership', 'Q507', (content) => content.replace(/\(.+\)/, ''));
    updateElTextContent('.js-apt-name', 'Q2');

    smoothScroll(document.querySelector('.js-thank-you'), 140);
  }

  /**
   * Filter the nav items based on a regular expression. The expression will
   * need to pass which items should be removed from the nav items. The expression
   * will be tested on the formNavItem ID.
   *
   * @example
   *  // Filter out js-your-details items
   *  const myCarItems = getFilteredNavItems(storedNavItems, /js-your-details/);
   * @param {FormNavItem[]} items The form nav items to filter
   * @param {RegExp} regex The regex to test the items with
   * @param {{ [key: string]: string[] }} [paths] Optional
   * paths paramenter to update the paths of an item when filtering
   */
  function getFilteredNavItems(items, regex, paths) {
    return items.reduce((newItems, formNavItem) => {
      if (!regex.test(formNavItem.id)) {
        newItems.push({
          ...formNavItem,
          step: newItems.length + 1,
          paths: paths && paths[formNavItem.id] ? paths[formNavItem.id] : formNavItem.paths,
        });
      }
      return newItems;
    }, []);
  }

  /**
   * Filter the nav items to use my-car items only and disable the dealership input
   */
  function initMyCarPage() {
    if (IS_MY_CAR_PAGE) {
      // Remove js-your-details from the items
      storedNavItems = getFilteredNavItems(storedNavItems, /js-your-details/);

      const dealerMessage = document.querySelector('.js-apt-dealer-msg');
      const dealerInput = document.querySelector('#Q507');

      if (dealerMessage && dealerInput) {
        dealerMessage.innerHTML =
          'You are having your <span class="js-apt-type" style="display: inline-block;"></span> at the below dealership:';
        dealerInput.disabled = true;
      }
    }
  }

  /**
   * Adds an autocomplete input to replace the dealership dropdown.
   * https://app.asana.com/0/1198921186553692/1199376027340746/f
   */
  // function initAutocompleteInput() {
  //   const dealerSelect = document.querySelector('#Q507');

  //   if (dealerSelect) {
  //     // Hide the dealerSelect in-case that there is code targeting it
  //     dealerSelect.style.opacity = '0';
  //     dealerSelect.style.visibility = 'hidden';
  //     dealerSelect.style.position = 'absolute';

  //     const parentElement = dealerSelect;
  //     parentElement.classList.add('autocomplete-container');

  //     // Create the autocomplete element
  //     const inputElement = document.createElement('input');
  //     inputElement.name = 'autocomplete';
  //     inputElement.id = 'autocomplete';
  //     inputElement.type = 'text';
  //     inputElement.className = 'form-control autocomplete-input';
  //     inputElement.value = dealerSelect.value;
  //     inputElement.setAttribute('autocomplete', 'off');

  //     const clearButton = document.createElement('div');
  //     clearButton.classList.add('autocomplete-clear');
  //     clearButton.innerHTML = '<i class="fal fa-times"></i>';

  //     if (!inputElement.value) {
  //       clearButton.classList.add('hide__default');
  //     }

  //     parentElement.insertAdjacentElement('afterbegin', inputElement);
  //     parentElement.insertAdjacentElement('beforeend', dealerSelect);
  //     parentElement.insertAdjacentElement('beforeend', clearButton);

  //     clearButton.addEventListener('click', () => {
  //       setElementValue(inputElement, '');
  //       setElementValue(dealerSelect, '');
  //       clearButton.classList.add('hide__default');
  //       formChangeHandler();
  //     });

  // eslint-disable-next-line max-len
  //     // Fallback in case that the dealership gets changed to bind the value to the autocomplete too
  // eslint-disable-next-line max-len
  //     dealerSelect.addEventListener('change', (event) => inputElement.value = event.target.value);

  //     // Initialize the autoComplete instance to add the functionality
  //     new window.autoComplete({
  //       data: {
  //         src: () => Array.from(dealerSelect.options).filter(option => !option.disabled),
  //         key: ['value'],
  //         cache: true,
  //       },
  //       sort: (a, b) => {
  //         if (a.match < b.match) return -1;
  //         if (a.match > b.match) return 1;
  //         return 0;
  //       },
  //       placeHolder: 'Select your dealership',
  //       selector: '#autocomplete',
  //       threshold: 0,
  //       searchEngine: 'strict',
  //       resultsList: {
  //         render: true,
  //         container: source => {
  //           source.setAttribute('class', 'autocomplete-list');
  //         },
  //         destination: parentElement,
  //         position: 'beforeend',
  //         element: 'ul',
  //       },
  //       maxResults: 200,
  //       highlight: true,
  //       resultItem: {
  //         content: (data, source) => {
  //           source.classList.add('autocomplete-list__item');
  //           source.innerHTML = data.match;

  //           clearButton.classList[inputElement.value ? 'remove' : 'add']('hide__default');
  //         },
  //         element: 'li',
  //       },
  //       noResults: () => {
  //         const result = document.createElement('li');
  //         result.className = 'autocomplete-list__item autocomplete-list__item--no-result';
  //         result.innerHTML = 'Sorry your search did not match any dealerships.';
  //         document.querySelector('#autoComplete_list').appendChild(result);
  //       },
  //       // Triggered when an option is selected
  //       onSelection: feedback => {
  //         setElementValue(inputElement, feedback.selection.value.textContent);
  //         setElementValue(dealerSelect, feedback.selection.value.value);
  //         clearButton.classList.remove('hide__default');
  //         formChangeHandler();
  //       },
  //       trigger: {
  //         condition: () => true,
  //         event: ['input', 'focus'],
  //       },
  //     });
  //   }
  // }

  /**
   * Initialize the functionality to handle the form
   */
  function init() {
    // If there is a hash remove it
    if (window.location.hash && !IS_MY_CAR_PAGE) {
      window.location.hash = '';
    }

    // Refire finance datalayer
    const financeDetails = window.sessionStorage.getItem('_financeDetails');
    if (financeDetails !== null && financeDetails.length > 0) {
      window.dataLayer.push(JSON.parse(financeDetails));
    }

    // Handle Google ReCaptcha
    handleGoogleRecaptcha();

    initMyCarPage();

    if (IS_SELL_YOUR_CAR_PAGE || SMC_COOKIE === 'Combined') {
      storedNavItems = getFilteredNavItems(storedNavItems, /js-your-appointment/, {
        'js-your-dealership': ['your-dealership', ''],
      });
    }

    // Is not the SMC page and is the book appointment page
    if (!IS_SELL_YOUR_CAR_PAGE && window.location.href.includes('book-an-appointment')) {
      const yourDetailsElement = document.getElementById('your-details');
      const positionFixedClass = document.querySelector('.position-fixed');
      if (yourDetailsElement && positionFixedClass) {
        positionFixedClass.classList.add('position-relative');
        positionFixedClass.classList.remove('position-fixed');

        // Remove the "position-fixed-container" class
        positionFixedClass.classList.remove('position-fixed-container');
      }
    }

    renderFormNavItems({
      items: storedNavItems,
      container: '.js-form-nav-container',
    });

    const appointmentForm = document.querySelector('#form_97');

    if (appointmentForm) {
      initAppointmentForm(appointmentForm);

      // Might not needed as we are using the dealer api to fetch dealerships
      // initAutocompleteInput();
    } else {
      initThankYouPage();
    }
    getFinanceSessionObject();
  }

  window.vm.onload(init);

  window.appointmentBooking = {
    goToFormStep,
    initThankYouPage,
    setElementValue,
    getFilteredNavItems,
    getItemFromSessionStorage,
    getItemFromVehDetails,
    // eslint-disable-next-line no-return-assign
    setStoredNavItems: (navItems) => (storedNavItems = navItems),
    getStoredNavItems: () => storedNavItems,
  };
})(window, document);
